export default __webpack_public_path__ + "static/media/tl-etf.a1b8d035.png";